import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('dropdown', {
  root: {
    states: ['noBorder', 'allowTextSelection'],
  },
});
